import { render, staticRenderFns } from "./viewWrapper.vue?vue&type=template&id=19815b06"
import script from "./viewWrapper.vue?vue&type=script&lang=js"
export * from "./viewWrapper.vue?vue&type=script&lang=js"
import style0 from "./viewWrapper.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports